import {createContext, useContext, useMemo, useReducer} from "react";
import { EventBusProvider } from "../stores/EventBusProvider";

const FormStateContext = createContext();
const FormStateDispatch = createContext();

const initialState = {
    products: null,
    categories: null,
    selectedCategory: null,
    selectedCategoryProduct: null,
    selectedPurchaseDate: null,
    selectedProduct: null,
    addresses: null,
    serialNumber: {},
    terminalId: {},
    files: [],
    orderControllerConfig: {},
    activeStep: {},
    phone: '',
    manualDeviceSelection: false,
    otherProductConversionButton: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "setActiveStep":
            return {
                ...state,
                activeStep: action.value,
            };
        case "setProducts":
            return {
                ...state,
                products: action.value,
            };
        case "setSelectedProduct":
            return {
                ...state,
                selectedProduct: action.value,
            };
        case "setCategories":
            return {
                ...state,
                categories: action.value,
            };
        case "verificationRequest":
            return {
                ...state,
                verificationRequest: action.value,
            };
        case "verificationCodeResponse":
            return {
                ...state,
                verificationCodeResponse: action.value,
            };
        case "setAddresses":
            return {
                ...state,
                addresses: action.value,
            };
        case "setSerialNumber":
            return {
                ...state,
                serialNumber: action.value,
            };
        case "setTerminalId":
            return {
                ...state,
                terminalId: action.value,
            };
        case "addFileUpload":
            return {
                ...state,
                files: [
                    ...state.files,
                    action.value,
                ],
            };
        case "removeFileUpload":
            return {
                ...state,
                files: state.files
                    .map((item, key) => ({
                        ...item,
                        originalIndex: key,
                    }))
                    .filter(item => item.originalIndex !== action.value),
            };
        case "clearFileUpload":
            return {
                ...state,
                files: [],
            };
        case "setOrder":
            return {
                ...state,
                order: action.value,
            };
        case "setSelectedCategory":
            return {
                ...state,
                selectedCategory: action.value,
                selectedCategoryProduct: null, // Reset selected product
                selectedPurchaseDate: null, // Reset selected purchase date

            };
        case "emailConfirmed":
            return {
                ...state,
                emailConfirmed: true,
            };
        case "setManualDeviceSelection":
            return {
                ...state,
                manualDeviceSelection: action.value,
            };
        case "setSelectedCategoryProduct":
            return {
                ...state,
                selectedCategoryProduct: action.value,
            };
        case "setSelectedPurchaseDate":
            return {
                ...state,
                selectedPurchaseDate: action.value,
            };
        case "setOtherProductConversionButton":
            return {
                ...state,
                otherProductConversionButton: action.value,
            };
        case "setValue":
            return {
                ...state,
                [action.key]: action.value,
            };
        default:
            throw new Error();
    }
}

export function FormState({ defaultState, children, }) {
    const initialStateFinal = useMemo( () => {
        return {
            ...initialState,
            ...defaultState,
        };
    }, []);

    const [state, dispatch] = useReducer(reducer, initialStateFinal);

    return (
        <EventBusProvider>
            <FormStateContext.Provider value={state}>
                <FormStateDispatch.Provider value={dispatch}>
                    { children }
                </FormStateDispatch.Provider>
            </FormStateContext.Provider>
        </EventBusProvider>
    );
}


export function useFormStateDispatch() {
    const context = useContext(FormStateDispatch);
    if (!context) {
        return {};
        // throw new Error("useOrderEntryDispatch must be used within OrderEntry");
    }
    return context;
}

export function useFormState() {
    const context = useContext(FormStateContext);
    if (!context) {
        return {};
        // throw new Error("useOrderEntryState must be used within OrderEntry");
    }
    return context;
}
